<template>
    <div class="home-frame">
        <Header
            class="home-header"
            :value="headerValue"
            @select="$emit('select', $event)"
        />
        <section class="hero-section" :style="heroSectionStyle">
            <img class="hero-image" :src="resolvedHeroImage" alt="page banner" />
        </section>
        <slot></slot>

        <section class="contact-strip">
            <div class="section-shell contact-shell">
                <div class="contact-qr">
                    <img :src="$gm('gzhqr.jpg')" alt="wechat qrcode" />
                    <div class="contact-caption">{{ $t("home.followWechat") }}</div>
                </div>
                <div class="contact-info">
                    <div class="contact-line contact-line-contacts">
                        <span>{{ contactPrefix }}</span>
                        <span class="contact-person">{{ firstContact }}</span>
                        <span class="contact-person">{{ secondContact }}</span>
                    </div>
                    <div class="contact-line">{{ recordText }}</div>
                </div>
                <div class="contact-info contact-address">
                    <div class="contact-line">{{ addressText }}</div>
                    <div class="contact-line">&nbsp;</div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Header from "@/components/header.vue";

export default {
    components: {
        Header,
    },
    props: {
        headerValue: {
            type: String,
            default: "0",
        },
        heroImage: {
            type: String,
            default: "2-1.png",
        },
        heroSrc: {
            type: String,
            default: "",
        },
        heroGap: {
            type: Number,
            default: 60,
        },
    },
    computed: {
        isEnglish() {
            return this.$i18n.locale === "en";
        },
        heroSectionStyle() {
            return {
                marginBottom: `${this.heroGap}px`,
            };
        },
        resolvedHeroImage() {
            return this.heroSrc || this.$gm(this.heroImage);
        },
        contactText() {
            return this.isEnglish
                ? "Contact:"
                : "联系方式：";
        },
        contactPrefix() {
            return this.contactText;
        },
        firstContact() {
            return this.isEnglish
                ? "Mr. Chen 15850576018"
                : "陈先生 15850576018";
        },
        secondContact() {
            return this.isEnglish
                ? "Ms. Zhou 15295583680"
                : "周女士 15295583680";
        },
        recordText() {
            return this.isEnglish
                ? "Record No.: Su ICP No. 05085572-16"
                : "2026备案号：苏ICP备05085572号-16";
        },
        addressText() {
            return this.isEnglish
                ? "Venue: Nanjing International Expo Center, 300 Jiangdong Middle Road, Jianye District, Nanjing"
                : "展会地址：南京国际博览中心（南京市建邺区江东中路300号）";
        },
    },
};
</script>

<style scoped lang="less">
.section-shell {
    width: 88%;
    margin: 0 auto;
}

.hero-section {
    width: 100%;
    line-height: 0;
}

.hero-image {
    width: 100%;
    display: block;
}

.contact-strip {
    padding: 36px 0 42px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    background-image: url("~@/assets/image/home-bg-4.png");
}

.contact-shell {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    clear: both;
    gap: 140px;
    color: #ffffff;
}

.contact-qr {
    text-align: center;
}

.contact-qr img {
    width: 180px;
    height: 180px;
    background: #ffffff;
}

.contact-caption {
    margin-top: 12px;
    font-size: 16px;
    color: #ffffff;
}

.contact-info {
    font-size: 16px;
    line-height: 2.2;
}

.contact-address {
    text-align: left;
}

.contact-line {
    line-height: 60px;
}

.contact-line-contacts {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 18px;
}

.contact-person + .contact-person {
    margin-left: 12px;
}

::v-deep(.home-header .info) {
    height: 70px;
    align-items: center;
    justify-content: center;
    padding: 0 46px;
    background: #47237a;
    position: relative;
}

::v-deep(.home-header .sign) {
    height: 64px !important;
}

::v-deep(.home-header .logo),
::v-deep(.home-header .login),
::v-deep(.home-header .info > .select) {
    display: none;
}

::v-deep(.home-header .nav) {
    padding-left: 0;
    gap: 84px;
}

::v-deep(.home-header .nav .item-info) {
    padding: 0;
    line-height: 64px;
}

::v-deep(.home-header .nav .item-info .title) {
    font-size: 21px;
    color: #ffffff;
    font-weight: 500;
    letter-spacing: 0.5px;
}

::v-deep(.home-header .nav #active),
::v-deep(.home-header .nav .item-info:hover) {
    background: transparent;
}

::v-deep(.home-header .nav #active .title),
::v-deep(.home-header .nav .item-info:hover .title),
::v-deep(.home-header .nav #active .nav-arrow),
::v-deep(.home-header .nav) {
    color: #2ce1ff;
}

::v-deep(.item-info:hover .nav-arrow) {
    color: #184ef6;
}

::v-deep(.home-header .nav .nav-arrow) {
    color: rgba(255, 255, 255, 0.92);
    width: 9px;
    height: 9px;
    margin-left: 10px;
    margin-top: -6px;
    border-right-width: 2px;
    border-bottom-width: 2px;
}

::v-deep(.home-header .nav .select) {
    margin-top: 0;
    padding: 8px 0;
    background: rgba(52, 28, 95, 0.96);
    box-shadow: 0 10px 24px rgba(21, 11, 43, 0.24);
}

::v-deep(.home-header .nav .select .select-item) {
    color: #ffffff;
    padding: 12px 20px 12px 16px;
}

::v-deep(.home-header .nav .select .select-item:hover) {
    background: rgba(44, 225, 255, 0.16);
    color: #2ce1ff;
}

::v-deep(.home-header .language) {
    height: 26px;
    margin-left: 54px;
    padding-left: 20px;
    line-height: 26px;
}

::v-deep(.home-header .language .sign),
::v-deep(.home-header .language .text) {
    color: #ffffff;
    font-size: 21px;
    font-weight: 500;
    letter-spacing: 1px;
}

::v-deep(.home-header .language #langactive) {
    color: #2ce1ff;
}

@media (max-width: 1366px) {
    .section-shell {
        width: 90%;
    }

    .contact-shell {
        gap: 40px;
        grid-template-columns: 180px minmax(0, 1fr) minmax(320px, 1fr);
    }

    .contact-line {
        line-height: 1.8;
    }

    ::v-deep(.home-header .info) {
        padding: 0 28px;
    }

    ::v-deep(.home-header .nav) {
        gap: 48px;
    }

    ::v-deep(.home-header .nav .item-info .title) {
        font-size: 18px;
    }

    ::v-deep(.home-header .language) {
        margin-left: 32px;
        padding-left: 18px;
    }

    ::v-deep(.home-header .language .sign),
    ::v-deep(.home-header .language .text) {
        font-size: 18px;
    }
}

@media (max-width: 1200px) {
    .section-shell {
        width: 92%;
    }

    .contact-shell {
        grid-template-columns: 1fr;
        gap: 24px;
        text-align: center;
    }

    .contact-address {
        text-align: center;
    }

    .contact-line {
        line-height: 1.8;
    }

    ::v-deep(.home-header .info) {
        padding: 0 20px;
    }

    ::v-deep(.home-header .nav) {
        gap: 24px;
    }

    ::v-deep(.home-header .nav .item-info) {
        line-height: 56px;
    }

    ::v-deep(.home-header .nav .item-info .title) {
        font-size: 16px;
    }

    ::v-deep(.home-header .language) {
        position: static;
        margin-left: 0;
        padding-left: 0;
        line-height: 56px;
    }

    ::v-deep(.home-header .language .sign),
    ::v-deep(.home-header .language .text) {
        font-size: 16px;
    }
}

@media (max-width: 992px) {
    ::v-deep(.home-header .info) {
        height: auto;
        padding: 12px 18px;
        flex-wrap: wrap;
        row-gap: 10px;
    }

    ::v-deep(.home-header .sign) {
        height: auto !important;
    }

    ::v-deep(.home-header .nav) {
        width: 100%;
        justify-content: center;
        flex-wrap: wrap;
        gap: 12px 20px;
    }

    ::v-deep(.home-header .nav .item-info) {
        line-height: 1.4;
    }

    ::v-deep(.home-header .language) {
        width: 100%;
        justify-content: center;
        line-height: 1.4;
    }
}

@media (max-width: 768px) {
    .section-shell {
        width: 94%;
    }

    .contact-shell {
        grid-template-columns: 1fr;
        gap: 18px;
        text-align: center;
    }

    .contact-address {
        text-align: center;
    }

    .contact-info {
        font-size: 15px;
        line-height: 1.8;
    }

    .contact-line {
        line-height: 1.7;
    }

    ::v-deep(.home-header .info) {
        padding: 10px 14px;
    }

    ::v-deep(.home-header .nav) {
        gap: 10px 16px;
    }

    ::v-deep(.home-header .nav .item-info .title) {
        font-size: 14px;
    }

    ::v-deep(.home-header .language .sign),
    ::v-deep(.home-header .language .text) {
        font-size: 14px;
    }
}

@media (max-width: 576px) {
    .contact-qr img {
        width: 140px;
        height: 140px;
    }

    .contact-info,
    .contact-caption {
        font-size: 14px;
    }

    ::v-deep(.home-header .nav) {
        gap: 8px 12px;
    }

    ::v-deep(.home-header .nav .item-info .title) {
        font-size: 13px;
    }

    ::v-deep(.home-header .language .sign),
    ::v-deep(.home-header .language .text) {
        font-size: 13px;
    }
}
</style>
